
import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardMedia from "@material-ui/core/CardMedia";
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';

class RenderFile extends React.Component {

    constructor(props)
    {
        super(props);
        this.state = {
            currentFile: null,
            activeLoading: false,
            filesToUpload: [],
            eventName :""

        }
        this.uploadButtonRef = React.createRef();

    }

	componentDidMount() {
        
    }

   
    render() {
        return (
            <Grid xs={3} sm={3}>
            <Card style={{margin:"5px"}}>
            <CardMedia
                image={this.props.uploadedFile.fileUrl}
                title="Imagen"
                style={{ width: "80px", height: "100px", margin: "auto" , marginTop: "0px"}}></CardMedia>
           
            </Card>
            </Grid>
            /*<div key={i} style={{width:"200px", height:"200px", display:"inline-flex"}}>
              <img src={fileUrl} style={{width:"100%", height:"100%"}}/>
            </div>*/
          )
        }
      
     }

  export default RenderFile;